import { motion } from "framer-motion";
import { Star } from "lucide-react";

const GOOGLE_REVIEW_URL = "https://www.google.com/maps/search/Parth+Travels+Akshat+Tower+Bodakdev+Ahmedabad";

const REVIEWS = [
  {
    quote: "We booked our Kerala family trip through Parth Travels and everything was arranged perfectly — flights, hotels and cabs. The team stayed in touch on WhatsApp throughout the journey.",
    initials: "SM",
    name: "Shah Family",
    tag: "Kerala Family Tour · Ahmedabad",
  },
  {
    quote: "Parth Travels handled our office offsite for the whole team — tickets, stay and local transport. One call was enough, and the billing was clear with proper GST invoice.",
    initials: "RD",
    name: "Rahul Desai",
    tag: "Corporate Offsite · HR Manager",
  },
  {
    quote: "My Dubai tourist visa and tickets were done quickly without any running around. They checked every document before filing, so there were no delays at all.",
    initials: "PN",
    name: "Priya Nair",
    tag: "Dubai Visa & Air Tickets",
  },
];

export const Reviews = () => (
  <section id="reviews" className="py-20 bg-stone-100 border-b border-stone-200" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto text-center mb-14">
        <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">Honest Feedback</span>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 mt-2 font-serif-display">
          Traveller Stories &amp; Experiences
        </h2>
        <p className="text-stone-600 text-sm mt-3">
          Real experiences from families, corporate teams, and solo vacationers who booked with Parth Travels.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {REVIEWS.map((r, i) => (
          <motion.div
            key={r.name}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="bg-white rounded-xl p-8 border border-stone-200 shadow-sm flex flex-col justify-between"
            data-testid={`review-card-${i + 1}`}
          >
            <div className="space-y-4">
              <div className="text-amber-500 text-sm tracking-widest">★★★★★</div>
              <p className="text-sm text-stone-700 italic">"{r.quote}"</p>
            </div>
            <div className="pt-6 border-t border-stone-100 mt-6 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-stone-200 text-stone-700 flex items-center justify-center font-bold text-xs">{r.initials}</div>
              <div>
                <span className="text-xs font-bold text-stone-900 block">{r.name}</span>
                <span className="text-[11px] text-stone-700">{r.tag}</span>
              </div>
            </div>
          </motion.div>
        ))}

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="bg-amber-50 rounded-xl p-8 border border-amber-200/80 shadow-sm flex flex-col justify-between text-center"
          data-testid="review-invite-card"
        >
          <div className="space-y-3">
            <span className="inline-block px-2.5 py-1 text-[11px] font-bold text-amber-900 bg-amber-200/70 rounded uppercase tracking-wider">Your Feedback Matters</span>
            <h4 className="text-lg font-bold text-stone-900">Traveled with us recently?</h4>
            <p className="text-xs text-stone-600 leading-relaxed">
              We take immense pride in making every vacation effortless. Share your experience with our team to help fellow travellers.
            </p>
          </div>
          <div className="pt-6 border-t border-amber-200/60 mt-6">
            <a href="#contact" data-testid="review-invite-link" className="text-xs font-bold text-amber-800 hover:text-amber-950 inline-flex items-center gap-1">
              Share your journey review →
            </a>
          </div>
        </motion.div>
      </div>

      <div className="text-center mt-10">
        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-review-btn"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white border border-stone-300 text-stone-800 text-sm font-bold shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
        >
          <Star className="w-4 h-4 text-amber-500 fill-amber-500" aria-hidden="true" />
          Review us on Google
        </a>
        <p className="text-[11px] text-stone-600 mt-2">Happy with our service? A public review helps other travellers find us.</p>
      </div>
    </div>
  </section>
);
